import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 16 16" {...props}><path d="M12.76 2.49c-2.253-.154-7.27-.153-9.52 0C.806 2.656.519 4.128.5 8c.018 3.866.302 5.343 2.74 5.51 2.25.153 7.267.154 9.52 0 2.435-.166 2.722-1.637 2.74-5.51-.018-3.866-.303-5.343-2.74-5.51zM6.124 10.5v-5l5 2.496-5 2.504z" /></svg>);